module.exports = __webpack_public_path__ + "static/netflix-ccxp-1-c563554c61e733d7f5a3734de4a731ba.jpg";